import { userService } from './service'; // 获取菜单列表

export function getmenu(data) {
  return userService({
    url: 'Menu/LoadData2Tree',
    params: data
  });
} // 获取菜单新增或编辑数据

export function getAddOrModify() {
  return userService({
    url: 'Menu/AddOrModify',
    method: 'get'
  });
} //  保存菜单

export function AddOrModifySave(data) {
  return userService({
    url: 'Menu/AddOrModifySave',
    method: 'post',
    data: data
  });
} //  删除菜单

export function MenuDelete(query) {
  return userService({
    url: 'Menu/Delete?id=' + query,
    method: 'post'
  });
} // 路由地址是否存在

export function IsExistsLinkUrl(data) {
  return userService({
    url: 'Menu/IsExistsLinkUrl',
    method: 'post',
    data: data
  });
} // 获取按钮

export function getLoadDataSub(query) {
  return userService({
    url: 'Menu/LoadDataSub?MENU_KIND=SCM',
    method: 'get',
    params: query
  });
} //  保存按钮

export function AddOrModifySubSave(query) {
  return userService({
    url: 'Menu/AddOrModifySubSave',
    method: 'post',
    data: query
  });
} // 删除按钮

export function DeleteSub(id) {
  return userService({
    url: 'Menu/DeleteSub?id=' + id,
    method: 'post'
  });
} // 获取角色的菜单列表数据

export function LoadMenusByRoleId(id) {
  return userService({
    // url: 'ManagerRole/LoadMenusByRoleId?roleId=' + id,
    url: "ManagerRole/LoadMenusByRoleId?roleId=".concat(id, "&menuKind=SCM"),
    method: 'get'
  });
} // 通过角色Id获取角色的按钮列表

export function GetAllButtonByRoleId(roleId) {
  return userService.get('ManagerRole/GetAllButtonByRoleId', {
    params: {
      menuKind: 'SCM',
      roleId: roleId
    }
  });
}